const v20 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        freelancersTable: {
          ...state.options.tableViews.freelancersTable,
          Department: true,
          Subunit: true,
          Role: true,
        },
      },
    },
  };
};

export default v20;
